// Module
var code = "<!-- ko foreach: value -->\n<!-- ko template: { nodes: $componentTemplateNodes } -->\n<!-- /ko -->\n<!-- /ko -->\n\n";
// Exports
module.exports = code;